// src/views/condominos/ImportarCondominosModal.jsx
import React, { useState } from "react";
import condominosService from "../../services/condominosService";
import condominiosService from "../../services/condominiosService";
import { useEffect } from "react";

// Parser CSV simples (suporta vírgula e ponto-e-vírgula, com aspas)
function parseCSV(text) {
  const sep = (text.split("\n")[0].split(";").length > text.split("\n")[0].split(",").length) ? ";" : ",";
  const rows = [];
  let row = [], cur = "", inQuotes = false;
  for (let i = 0; i < text.length; i++) {
    const ch = text[i];
    if (inQuotes) {
      if (ch === '"' && text[i+1] === '"') { cur += '"'; i++; }
      else if (ch === '"') inQuotes = false;
      else cur += ch;
    } else {
      if (ch === '"') inQuotes = true;
      else if (ch === sep) { row.push(cur); cur = ""; }
      else if (ch === "\n") { row.push(cur); rows.push(row); row = []; cur = ""; }
      else if (ch === "\r") { /* skip */ }
      else cur += ch;
    }
  }
  if (cur || row.length) { row.push(cur); rows.push(row); }
  return rows.filter(r => r.some(c => (c||"").trim()));
}

const COLUNAS_VALIDAS = ["nmCompleto","cpf_cnpj","tpPessoa","email","celular","unidade","bloco","tpVinculo"];

export default function ImportarCondominosModal({ show, onClose, onImported }) {
  const [arquivo, setArquivo] = useState(null);
  const [headers, setHeaders] = useState([]);
  const [linhas, setLinhas] = useState([]);
  const [mapeamento, setMapeamento] = useState({});
  const [idCondominio, setIdCondominio] = useState("");
  const [condominios, setCondominios] = useState([]);
  const [enviando, setEnviando] = useState(false);
  const [resultado, setResultado] = useState(null);
  const [erro, setErro] = useState(null);

  useEffect(() => {
    if (!show) return;
    setArquivo(null); setHeaders([]); setLinhas([]); setMapeamento({}); setResultado(null); setErro(null);
    condominiosService.listar({ limit: 100 }).then(r => setCondominios(r.data||[])).catch(()=>{});
  }, [show]);

  const onFile = async (f) => {
    if (!f) return;
    setArquivo(f); setErro(null); setResultado(null);
    try {
      const text = await f.text();
      const rows = parseCSV(text);
      if (!rows.length) { setErro("Arquivo vazio."); return; }
      const hd = rows[0].map(h => (h||"").trim());
      setHeaders(hd);
      setLinhas(rows.slice(1));
      // auto-map por nome
      const m = {};
      hd.forEach((h, i) => {
        const k = h.toLowerCase().replace(/[^a-z0-9]/g,"");
        const match = COLUNAS_VALIDAS.find(c => c.toLowerCase().replace(/[^a-z0-9]/g,"") === k);
        if (match) m[match] = i;
      });
      setMapeamento(m);
    } catch(e) { setErro("Erro ao ler arquivo: " + e.message); }
  };

  const enviar = async () => {
    if (!linhas.length) return setErro("Sem linhas para importar.");
    if (mapeamento.nmCompleto === undefined) return setErro("Mapeie a coluna do nome.");
    setEnviando(true); setErro(null);
    const registros = linhas.map(row => {
      const obj = {};
      Object.entries(mapeamento).forEach(([k, idx]) => {
        if (idx !== undefined && idx !== "") obj[k] = (row[idx]||"").trim();
      });
      return obj;
    }).filter(r => r.nmCompleto);
    try {
      const r = await condominosService.importar({ idCondominio: idCondominio || null, registros });
      setResultado(r);
      if (onImported) onImported();
    } catch(e) { setErro(e.message); }
    setEnviando(false);
  };

  if (!show) return null;
  return (
    <div className="modal fade show d-block" style={{background:"rgba(0,0,0,.55)"}} tabIndex="-1">
      <div className="modal-dialog modal-xl modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title"><i className="bi bi-upload me-2"/>Importar Condôminos / Unidades (CSV)</h5>
            <button className="btn-close btn-close-white" onClick={onClose}/>
          </div>
          <div className="modal-body">
            {erro && <div className="alert alert-danger" style={{fontSize:13}}><i className="bi bi-exclamation-triangle-fill me-2"/>{erro}</div>}

            <div className="form-section">
              <div className="form-section-title"><i className="bi bi-info-circle"/> Modelo do CSV</div>
              <p style={{fontSize:13,color:"var(--gray-600)"}}>
                Colunas reconhecidas (case-insensitive): <code>{COLUNAS_VALIDAS.join(", ")}</code>.<br/>
                <strong>nmCompleto</strong> é obrigatório. Se passar <strong>unidade</strong> + escolher um condomínio, criamos a unidade e vínculo automaticamente.
              </p>
              <a href={`data:text/csv;charset=utf-8,${encodeURIComponent("nmCompleto;cpf_cnpj;tpPessoa;email;celular;unidade;bloco;tpVinculo\nJoão Silva;123.456.789-09;Fisica;joao@x.com;(11) 99999-9999;101;A;Proprietario\n")}`}
                download="modelo_condominos.csv" className="btn btn-sm btn-outline-primary">
                <i className="bi bi-download me-1"/>Baixar modelo
              </a>
            </div>

            <div className="form-section">
              <div className="form-section-title"><i className="bi bi-file-earmark-spreadsheet"/> Arquivo</div>
              <div className="row g-2 align-items-end">
                <div className="col-md-5">
                  <label className="form-label" style={{fontSize:12}}>CSV (separador ; ou ,)</label>
                  <input type="file" accept=".csv,text/csv" className="form-control form-control-sm" onChange={e=>onFile(e.target.files?.[0])}/>
                </div>
                <div className="col-md-5">
                  <label className="form-label" style={{fontSize:12}}>Condomínio (para criar/vincular unidades)</label>
                  <select className="form-select form-select-sm" value={idCondominio} onChange={e=>setIdCondominio(e.target.value)}>
                    <option value="">— Apenas condôminos (sem vínculo) —</option>
                    {condominios.map(c => <option key={c.id} value={c.id}>{c.nmFantasia || c.nmCondominio}</option>)}
                  </select>
                </div>
                <div className="col-md-2">
                  <span style={{fontSize:12,color:"var(--gray-500)"}}>{linhas.length ? `${linhas.length} linha(s)` : ""}</span>
                </div>
              </div>
            </div>

            {headers.length > 0 && (
              <div className="form-section">
                <div className="form-section-title"><i className="bi bi-arrow-left-right"/> Mapeamento de colunas</div>
                <div className="row g-2">
                  {COLUNAS_VALIDAS.map(c => (
                    <div className="col-md-3" key={c}>
                      <label className="form-label" style={{fontSize:12}}>{c}{c==="nmCompleto" && <span className="text-danger ms-1">*</span>}</label>
                      <select className="form-select form-select-sm" value={mapeamento[c] ?? ""} onChange={e=>setMapeamento(p=>({...p,[c]:e.target.value===""?undefined:Number(e.target.value)}))}>
                        <option value="">— ignorar —</option>
                        {headers.map((h,i)=><option key={i} value={i}>{h||`Coluna ${i+1}`}</option>)}
                      </select>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {resultado && (
              <div className="alert alert-success" style={{fontSize:13}}>
                <h6 className="mb-2"><i className="bi bi-check-circle-fill me-2"/>Importação concluída</h6>
                <ul className="mb-1">
                  <li>Total processado: <strong>{resultado.total}</strong></li>
                  <li>Condôminos novos: <strong>{resultado.condominosNovos}</strong></li>
                  <li>Condôminos já existentes (vinculados): <strong>{resultado.condominosVinc}</strong></li>
                  <li>Unidades novas criadas: <strong>{resultado.unidadesNovas}</strong></li>
                  <li>Vínculos novos: <strong>{resultado.vinculosCriados}</strong></li>
                  <li>Ignorados: <strong>{resultado.ignorados}</strong></li>
                  <li>Erros: <strong className="text-danger">{resultado.erros}</strong></li>
                </ul>
                {resultado.detalhesErros?.length > 0 && (
                  <details><summary>Ver erros</summary>
                    <ul style={{fontSize:11.5}}>{resultado.detalhesErros.map((e,i)=><li key={i}>{e}</li>)}</ul>
                  </details>
                )}
              </div>
            )}
          </div>
          <div className="modal-footer">
            <button className="btn btn-outline-secondary" onClick={onClose}>Fechar</button>
            <button className="btn btn-primary" onClick={enviar} disabled={enviando||!linhas.length||mapeamento.nmCompleto===undefined}>
              {enviando ? <><span className="spinner-border spinner-border-sm me-2"/>Importando...</> : <><i className="bi bi-upload me-2"/>Importar {linhas.length||""}</>}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
